module.exports = __webpack_public_path__ + "img/symbol_10.3e3d76e6.png";